export default "__VITE_ASSET__60dda203__"